import ArrowRightCircle from '@/components/icons/ArrowRightCircle';
import Trash from '@/components/icons/Trash';
import { ISelectNumeroAgrement } from '@/types';
import { Dispatch, SetStateAction, useState } from 'react';
import styles from './style.module.css';

const TableSelect: React.FC<{
  pdvs?: ISelectNumeroAgrement[];
  setPdvs: Dispatch<SetStateAction<ISelectNumeroAgrement[]>>;
}> = ({ pdvs, setPdvs }) => {
  const [checkedPdvs, setCheckedPdvs] = useState<string[]>([]);

  const checkPdv = (e: any, id: string) => {
    if (e.target.checked) setCheckedPdvs((prevPdvs) => [...prevPdvs, id]);
    else setCheckedPdvs((prevPdvs) => prevPdvs.filter((pdv) => pdv !== id));
  };

  const addSelectedOption = () => {
    setPdvs((prevPdvs) =>
      prevPdvs.map((pdv) => {
        if (checkedPdvs.includes(pdv.bnppf_pos_id)) {
          return {
            ...pdv,
            added: true,
          };
        }
        return pdv;
      })
    );
    setCheckedPdvs([]);
  };

  const deleteOption = (id: string) => {
    const newPdvs = pdvs?.map((pdv) => {
      if (pdv.bnppf_pos_id == id) {
        return {
          ...pdv,
          added: false,
        };
      }
      return pdv;
    });
    setPdvs(newPdvs || []);
  };

  const isChecked = (id: string): boolean => {
    return checkedPdvs.includes(id);
  };

  const areAllOptionsChecked = (): boolean => {
    if (checkedPdvs.length === 0) return false;
    return (
      pdvs
        ?.filter((pdv) => !pdv.added)
        .every((pdv) => checkedPdvs.includes(pdv.bnppf_pos_id)) || false
    );
  };

  const selectAll = (e: any) => {
    if (e.target.checked) {
      pdvs
        ?.filter((pdv) => !pdv.added)
        .map((pdv) =>
          setCheckedPdvs((prevPdvs) => [...prevPdvs, pdv.bnppf_pos_id])
        );
    } else setCheckedPdvs([]);
  };

  const deleteAll = () => {
    setPdvs((prevPdvs) =>
      prevPdvs.map((pdv) => {
        return {
          ...pdv,
          added: false,
        };
      })
    );
  };

  return (
    <div className={`flex-row gap-s ${styles.wrapper}`}>
      <div className={styles.table}>
        <div className={`flex-row gap-s ${styles.head}`}>
          <p className="bold">Numéros d’agrément disponibles</p>{' '}
          <input
            type="checkbox"
            onChange={selectAll}
            checked={areAllOptionsChecked()}
          />
        </div>
        <div className={styles['table-content']}>
          {pdvs
            ?.filter((pdv) => !pdv.added)
            .map((pdv, index) => {
              return (
                <div key={index} className={`flex-row gap-s ${styles.row}`}>
                  <p>
                    <b>{pdv.bnppf_pos_id} - </b>
                    {pdv.name}
                  </p>
                  <input
                    type="checkbox"
                    onChange={(e) => checkPdv(e, pdv.bnppf_pos_id)}
                    checked={isChecked(pdv.bnppf_pos_id)}
                  />
                </div>
              );
            })}
        </div>
      </div>
      <div onClick={addSelectedOption}>
        <ArrowRightCircle />
      </div>
      <div className={styles.table}>
        <div className={`flex-row gap-s ${styles.head}`}>
          <p className="bold">Numéros d’agrément de l’employé</p>{' '}
          <div onClick={deleteAll}>
            <Trash className={styles.icon} />
          </div>
        </div>
        <div className={styles['table-content']}>
          {pdvs
            ?.filter((pdv) => pdv.added)
            .map((pdv, index) => {
              return (
                <div key={index} className={`flex-row gap-s ${styles.row}`}>
                  <p>
                    <b>{pdv.bnppf_pos_id} - </b>
                    {pdv.name}
                  </p>
                  <div onClick={() => deleteOption(pdv.bnppf_pos_id)}>
                    <Trash className={styles.icon} />
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default TableSelect;
